import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { FeatureFlagsService } from './feature-flags';

export const Ng1FeatureFlagsModule = angular
  .module('control-room.shared.services.feature-flags', [])
  .factory('crFeatureFlagsService', downgradeInjectable(FeatureFlagsService));